import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { LayoutDashboard, FileText, CalendarDays, MessageSquare, MoreHorizontal } from 'lucide-react';

const BOTTOM_ITEMS = [
  { path: '/dashboard', label: 'Home', icon: LayoutDashboard },
  { path: '/leads', label: 'Leads', icon: FileText },
  { path: '/appointments', label: 'Calendar', icon: CalendarDays },
  { path: '/messages', label: 'Chat', icon: MessageSquare },
  { path: '/more', label: 'More', icon: MoreHorizontal },
];

export default function BottomNav() {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) return null;

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 dark:bg-slate-900/95 backdrop-blur border-t border-slate-200 dark:border-slate-800 lg:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      data-testid="bottom-nav"
      aria-label="Mobile bottom navigation"
    >
      <div className="flex items-stretch justify-around h-14 max-w-lg mx-auto">
        {BOTTOM_ITEMS.map(item => {
          const active = isActive(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`relative flex flex-col items-center justify-center flex-1 gap-0.5 transition-colors min-h-[44px] ${
                active
                  ? 'text-[#0047AB] dark:text-blue-400'
                  : 'text-slate-500 dark:text-slate-400 active:text-slate-700 active:bg-slate-50 dark:active:bg-slate-800'
              }`}
              data-testid={`bottom-nav-${item.label.toLowerCase()}`}
              aria-label={item.label}
            >
              <item.icon className="w-5 h-5" strokeWidth={active ? 2.4 : 1.8} />
              <span className={`text-[10px] leading-none ${active ? 'font-semibold' : 'font-medium'}`}>
                {item.label}
              </span>
              {active && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-[#0047AB] dark:bg-blue-400 rounded-b-full" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
